"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var number_1 = require("@seaweb/coral/utils/number");
var useEventCallback_1 = __importDefault(require("./useEventCallback"));
function useRovingIndex() {
    var itemsRef = react_1.useRef({});
    var setItemRef = useEventCallback_1.default(function (index, el) {
        itemsRef.current[index] = el;
    });
    var getIndexes = useEventCallback_1.default(function () {
        return Object.entries(itemsRef.current)
            .filter(function (_a) {
            var _b = __read(_a, 2), el = _b[1];
            return el;
        })
            .map(function (_a) {
            var _b = __read(_a, 1), idx = _b[0];
            return +idx;
        })
            .sort(function (a, b) { return a - b; });
    });
    var getRelativeTarget = useEventCallback_1.default(function (index, distance, _a) {
        var _b = (_a === void 0 ? {} : _a).overflow, overflow = _b === void 0 ? 'cycle' : _b;
        var indices = getIndexes();
        var ownIndex = indices.indexOf(index);
        var targetIndexIndex = ownIndex + distance;
        switch (overflow) {
            case 'cycle':
                targetIndexIndex = number_1.mod(ownIndex + distance, indices.length);
                break;
            case 'clamp':
                targetIndexIndex = number_1.clamp(ownIndex + distance, 0, indices.length - 1);
                break;
            default:
        }
        var targetIndex = indices[targetIndexIndex];
        var target = itemsRef.current[targetIndex];
        return [target, targetIndex, targetIndexIndex];
    });
    var getItem = useEventCallback_1.default(function (th) {
        var indices = getIndexes();
        var targetIndexIndex = number_1.mod(th, indices.length);
        var targetIndex = indices[targetIndexIndex];
        var target = itemsRef.current[targetIndex];
        return [target, targetIndex, targetIndexIndex];
    });
    return {
        itemsRef: itemsRef,
        setItemRef: setItemRef,
        getIndexes: getIndexes,
        getRelativeTarget: getRelativeTarget,
        getItem: getItem,
    };
}
exports.default = useRovingIndex;
